module.exports = __webpack_public_path__ + "static/img/pic_coop02@2x.c7312b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/pic_coop02@2x.png
// module id = 82y3
// module chunks = 0